// Real pages from LØPEKLAR™ Bind 1 (Gamma Studio), WebP 1512×1890 in Recursos Impultienda (tienda LØPEKLAR).
// InsidePages only shows entries with a src. Never use images from another product here.
const IMG_BASE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/7b6e8e6c-a05d-40f3-8995-4adc5b5ab410/';

export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [
  {
    src: `${IMG_BASE}1792686057526_lopeklar-bind1-s01-forside-e5db5bbb.webp`,
    label: 'Bind 1 · Forside',
    title: 'Årsplan, periodisering og 12 ferdige fellesøkter',
    text: 'Bind 1 samler årshjulet og tolv fellesøkter minutt for minutt – med øktkort til utskrift og tre nivåer i hver økt.'
  },
  {
    src: `${IMG_BASE}1792686061194_lopeklar-bind1-s04-arshjul-67d41e37.webp`,
    label: 'Årshjul · Side 4',
    title: 'Årshjulet for løpegruppen',
    text: 'Hele sesongen på ett ark: grunntrening høst og vinter, spesifikk trening om våren, konkurranse og overgang – uke for uke.'
  },
  {
    src: `${IMG_BASE}1792686065263_lopeklar-bind1-s11-soner-2abcfdf0.webp`,
    label: 'Soner · Side 11',
    title: 'Intensitetssonene I1–I5',
    text: 'Følelse, pratetest og omtrentlig prosent av makspuls for hver sone – med eksempel på økter.'
  },
  {
    src: `${IMG_BASE}1792686069137_lopeklar-bind1-s14-okt2-00858cac.webp`,
    label: 'Fellesøkt · Side 14',
    title: 'Økt 2: Bakkeintervaller minutt for minutt',
    text: 'Trenerens side: oppvarming 0–15, hoveddel 15–50 og nedjogg 50–60, med mål, sone, utstyr og trenerens instruksjon.'
  },
  {
    src: `${IMG_BASE}1792686073522_lopeklar-bind1-s31-oktkort-lysloype-a11007b5.webp`,
    label: 'Øktkort · Side 31',
    title: 'Økt 10: Lysløype i mørketiden',
    text: 'Øktkort med løypeskisse (samlepunkt, mørk del og snupunkt), tre nivåer og hva du gjør ved glatt føre.'
  }
];
